import InterestComboBox from './InterestComboBox';
export default InterestComboBox;



// WEBPACK FOOTER //
// ./src/components/common/InterestComboBox/index.js